import { fetchWithToken } from '@utils';

export interface SubmitDataProps {
  payload: any;
  isLoggedInUser: boolean;
  endpoint: string;
}

export const SubmitData = async ({
  payload,
  isLoggedInUser,
  endpoint,
}: SubmitDataProps) => {
  try {
    const fetchFunc = isLoggedInUser ? fetchWithToken : fetch;
    const response = await fetchFunc(
      `${import.meta.env.VITE_APIM_BASE_URL}${endpoint}`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY as string}`,
          'content-type': 'application/json',
        },
      },
    );
    const submitResponse = await response.json();
    if (!submitResponse || !submitResponse.case_reference) {
      throw new Error('Failed to submit report');
    }
    return submitResponse;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};
